<template>
<div class="shopCarBg">
	<div class="w">
		<shopCarCom></shopCarCom>
	</div>
</div>
</template>

<script>
import shopCarCom from "@/components/shopCarCom";

export default {
	components: {
		shopCarCom
	}
};
</script>

<style lang="scss" scoped>
.shopCarBg {
	background: #eff2f7;
	padding: 20px;
}
</style>